// utility file

// Strips any alpha channel from an `rgba(...)` color string, returning a
// fully solid `rgb(...)` with the same base color — used to guarantee an
// opaque surface while still deriving the color from the app's own design
// tokens (several of which, like `popoverBg`/`chatBg`, are intentionally
// translucent for the full page's glass effect but need to render fully
// solid on a small floating widget). Non-rgba inputs (hex, plain rgb) pass
// through unchanged since they're already opaque.
export const toOpaqueColor = (color) => {
  if (typeof color !== 'string') return color;
  const match = color.match(/^rgba\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*[\d.]+\s*\)$/i);
  if (!match) return color;
  const [, r, g, b] = match;
  return `rgb(${r}, ${g}, ${b})`;
};

export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ').filter((p) => p.length > 0);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0] ? parts[0][0].toUpperCase() : '?';
};

export const getTrilateralName = (name) => {
  if (!name) return '';
  const parts = name.trim().split(' ').filter((p) => p.length > 0);
  if (parts.length >= 3) {
    return `${parts[0]} ${parts[1]} ${parts[2]}`;
  }
  return name.trim();
};

export const formatTime = (dateString, t = { justNow: 'Just now' }) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diff = now - date;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (minutes < 1) return t.justNow;
  if (minutes < 60) return `${minutes}m`;
  if (hours < 24) return `${hours}h`;
  if (days < 7) return `${days}d`;
  return date.toLocaleDateString();
};

export const formatMessageTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

export const getAvatarColor = (name) => {
  const colors = ['#3b82f6', '#a855f7', '#ec4899', '#10b981', '#f97316', '#ef4444'];
  const index = (name || '').charCodeAt(0) % colors.length;
  return colors[index];
};